import Box from "@ui-kit/layout/Box/Box.web";
import Logo from "@shared/assets/Logo/Logo.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import dynamic from "next/dynamic";
import NavBarLocaleMenu from "@shared/components/application/navigation/NavBarLocaleMenu/NavBarLocaleMenu.web";
import Link from "next/link";
import WebviewComponentAdaptor from "@shared/components/application/other/WebviewComponentAdaptor/WebviewComponentAdaptor.web";

const CheckoutNavBarMobile = dynamic(
  () => import("../CheckoutNavBarMobile/CheckoutNavBarMobile.web"),
  {
    ssr: false,
  }
);

const CartTimerCheckout = dynamic(
  () =>
    import(
      "@shared/components/application/data-display/CartTimer/CartTimerCheckout.web"
    ),
  {
    ssr: false,
  }
);

const NavBarUserMenu = dynamic(
  () => import("@ui-application/navigation/NavBarUserMenu/NavBarUserMenu.web"),
  {
    ssr: false,
  }
);

type ContentProps = {
  showTimer?: boolean;
};

export default function CheckoutNavBarHeader({
  showTimer = true,
}: ContentProps): JSX.Element {
  return (
    <Flex direction="row" justify="space-between" alignItems="center">
      <WebviewComponentAdaptor
        webComponent={
          <CheckoutNavBarHeader.WebComponent showTimer={showTimer} />
        }
        webviewComponent={
          <CheckoutNavBarHeader.WebviewComponent showTimer={showTimer} />
        }
      />
    </Flex>
  );
}

CheckoutNavBarHeader.WebviewComponent = function WebviewComponent({
  showTimer,
}: ContentProps) {
  return (
    <>
      <Box>
        <Logo h="element.xl" w="auto" fill="secondary.500" />
      </Box>
      <Flex direction="row" alignItems="center">
        <Box hidden={!showTimer}>
          <CartTimerCheckout />
        </Box>
      </Flex>
    </>
  );
};

CheckoutNavBarHeader.WebComponent = function WebComponent({
  showTimer,
}: ContentProps) {
  return (
    <>
      <Link href="/" passHref>
        <Box cursor="pointer">
          <Logo h="element.xl" w="auto" fill="secondary.500" />
        </Box>
      </Link>
      <Flex direction="row" gap="md" alignItems="center">
        {showTimer && (
          <Box>
            <CartTimerCheckout />
          </Box>
        )}
        <Box display={{ base: "none", sm: "block" }}>
          <NavBarLocaleMenu />
        </Box>
        <Box>
          <Box display={{ base: "block", sm: "none" }}>
            <CheckoutNavBarMobile />
          </Box>
          <Box display={{ base: "none", sm: "block" }}>
            <NavBarUserMenu />
          </Box>
        </Box>
      </Flex>
    </>
  );
};
